export default __webpack_public_path__ + "locales/nl/DataReassignmentDialog.json?hash=e55db7c46f1a22714044206ccbaa128c";